import type {EventDocument} from 'prismicio-types'
import type {FC} from 'react'
import type {useEventLabels} from '../hooks/useEventLabels'
import {EventCard} from './EventCard'

type EventsGridProps = {
  events: EventDocument<string>[]
  labels: ReturnType<typeof useEventLabels>['cards']
}

export const EventsGrid: FC<EventsGridProps> = ({events, labels}) => (
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
    {events.map((event) => (
      <EventCard key={event.id + event.lang} event={event} labels={labels} />
    ))}
  </div>
)
